<div class="pedido-nao-liberado-card-info" *ngIf="input">
    <!-- Bonificação Excedente -->
    <ng-template [ngIf]="config?.isMotivoNaoLiberadoBonificacaoExcedente">
        <sgt-pedido-nao-liberado-card-info-bonificacao-excedente
            [tipoVenda]="input.tipoVenda"
            [dataNaoLiberado]="input.dataNaoLiberado"
            [campanha]="input.campanha"
            [valorRegraNaoLiberado]="input.valorRegraNaoLiberado"
            [valorBonificacaoNaoLiberado]="input.valorBonificacaoNaoLiberado"
            [percBonificacaoMaximaNaoLiberado]="input.percBonificacaoMaximaNaoLiberado"
            [percBonificacaoNaoLiberado]="input.percBonificacaoNaoLiberado"
            [percBonificacaoExcedente]="percBonificacaoExcedente">
        </sgt-pedido-nao-liberado-card-info-bonificacao-excedente>
    </ng-template>

    <!-- Descontos dos Itens Excedidos -->
    <ng-template [ngIf]="config?.isMotivoNaoLiberadoPercDescontosMaximosItensExcedidos">
        <sgt-pedido-nao-liberado-card-info-descontos-maximos-itens-excedidos
            [idPedido]="input.id"
            [tipoVenda]="input.tipoVenda"
            [dataNaoLiberado]="input.dataNaoLiberado">
        </sgt-pedido-nao-liberado-card-info-descontos-maximos-itens-excedidos>
    </ng-template>

    <!-- Lucro Líquido Abaixo -->
    <ng-template [ngIf]="config?.isMotivoNaoLiberadoLucroLiquidoAbaixo">
        <sgt-pedido-nao-liberado-card-info-lucro-liquido-abaixo
            [tipoVenda]="input.tipoVenda"
            [dataNaoLiberado]="input.dataNaoLiberado"
            [drp]="input.drp">
        </sgt-pedido-nao-liberado-card-info-lucro-liquido-abaixo>
    </ng-template> 
    
    <!-- Cliente Inadimplente -->
    <ng-template [ngIf]="config?.isMotivoNaoLiberadoClienteInadimplente">
        <sgt-pedido-nao-liberado-card-info-cliente-inadimplente
            [settings]="input">
        </sgt-pedido-nao-liberado-card-info-cliente-inadimplente>
    </ng-template> 
    
    <!-- Limite de Crédito Excedido -->
    <ng-template [ngIf]="config?.isMotivoNaoLiberadoLimiteCreditoExcedido">
        <sgt-pedido-nao-liberado-card-info-limite-credito-excedido
            [settings]="input">
        </sgt-pedido-nao-liberado-card-info-limite-credito-excedido>
    </ng-template>     
</div>